import { useQuery } from '@tanstack/react-query'
import { api, PublicBridgeConfig } from '@/lib/api'

export function useBridgeConfig() {
  const { data, isLoading, error, refetch } = useQuery<PublicBridgeConfig>({
    queryKey: ['bridgeConfig'],
    queryFn: () => api.getPublicBridgeConfig(),
    staleTime: 30000,
    retry: 2,
  })

  return {
    config: data,
    feePercentage: data?.feePercentage ?? 1,
    minAmount: data?.minAmount,
    maxAmount: data?.maxAmount,
    minAmountFormatted: data?.minAmountFormatted ?? '10',
    maxAmountFormatted: data?.maxAmountFormatted ?? '10000',
    isPaused: data?.isPaused ?? false,
    pauseReason: data?.pauseReason,
    showQueuePosition: data?.showQueuePosition ?? false,
    p2pEnabled: data?.p2pEnabled ?? false,
    lockContractAddress: data?.lockContractAddress,
    isLoading,
    error,
    refetch,
  }
}
